/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
// eslint-disable-next-line jira/restricted/fedramp-isolated-cloud
import { isFedRamp } from '@atlassian/atl-context';
import { fg } from '@atlassian/jira-feature-gating';

export const isDevopsFeatureDisabledInFedRamp = (): boolean =>
	fg('aem_migration_jira') ? !isFeatureEnabled('jira', 'jira-software-devops') : isFedRamp();
